import config from '../config.json';

export function primaryAPI() {
	return config[process.env.REACT_APP_STAGE].api.primaryAPI;
}
